import { ChakraButton as Button } from "@airhelp/react-ui-components";
import type { As, ButtonProps } from "@chakra-ui/react";
import { useModal } from "contexts/ModalContext";
import { useStoryblokLink } from "hooks";
import type { ReactStoryblokComponent } from "types/storyblok";
import { trackUAClickEvent, trackCustomEvent } from "utils/tracking/utils";
import { modals, sizes, variants } from "./Button.config";
import type { ButtonStoryblokAdapterProps } from "./Button.d";

const ButtonStoryblokAdapter = ({
  blok: {
    size,
    text,
    variant,
    link,
    modal,
    modalSize = "md",
    gtmSection,
    gtmElement,
    gaLabel,
    gaPlacement,
    isExternal
  },
  sbEditable,
}: ReactStoryblokComponent<ButtonStoryblokAdapterProps>) => {
  const { openModal } = useModal();
  const href = useStoryblokLink(link);

  const trackingEvents = () =>  {
    trackUAClickEvent(gtmSection, gtmElement);
    trackCustomEvent({ event: "cta_click", label: gaLabel, placement: gaPlacement });
  }

  const buttonModalProps = {
    size: sizes[size],
    onClick: () => {
      openModal(modals[modal], modalSize);
      trackingEvents();
    },
    variant: variants[variant],
    minW: "fit-content",
    whiteSpace: "nowrap",
  } as ButtonProps;

  const buttonProps = {
    onClick: trackingEvents,
    variant: variants[variant],
    size: sizes[size],
    as: "a" as As<unknown>,
    href,
    target: isExternal ? "_blank" : "_self",
  };

  const props = modal ? buttonModalProps : buttonProps;

  return (
    <Button {...props} {...sbEditable}>
      {text}
    </Button>
  );
};

export default ButtonStoryblokAdapter;
